import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  PLATFORM_ID,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { BreadCrumbsComponent } from '../../../../../../Shared/components/bread-crumbs/bread-crumbs.component';
import { Breadcrumb } from 'src/app/Shared/_models/breadcrumb.model';
import { BuyerPageOptionsComponent } from '../../../../buyer-shared/components/buyer-page-options/buyer-page-options.component';
import { PaginationResultsComponent } from '../../../../../../Shared/components/pagination-results/pagination-results.component';
import {
  CardsPerPage,
  getPaginationData,
  ItemsPerPage,
} from 'src/app/_utlis/pagination-helper';
import { Subscription, Subject, debounceTime } from 'rxjs';
import { Navigation } from 'src/app/_utlis/navigateToLanding';
import { ActivatedRoute, Router } from '@angular/router';
import {
  CommonModule,
  isPlatformBrowser,
  NgClass,
  NgFor,
  NgIf,
} from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { ToastService } from 'src/app/Shared/services/toast/toast.service';
import { TranslateService } from '@ngx-translate/core';
import { AuctionService } from '../../_services/auction/auction.service';
import { Auction } from '../../_interfaces/auction.interface';
import { IPagination } from 'src/app/Shared/_models/pagination.model';
import { Title } from '@angular/platform-browser';
import { BuyerAuctionCardComponent } from 'src/app/app-modules/buyer/buyer-shared/components/buyer-auction-card/buyer-auction-card.component';
import { BuyerAuthService } from 'src/app/app-modules/buyer/buyer-core/buyer-authentication/services/buyer-auth/buyer-auth.service';
import { StorageService } from 'src/app/Core/_services/storage/storage.service';
import { PaginationComponent } from 'src/app/Shared/components/pagination/pagination.component';
import { TermsAndConditionsAcceptanceService } from 'src/app/app-modules/buyer/buyer-shared/services/terms-and-conditions-acceptance.service';
import { getAuctionChannels } from '../../_PusherEvents/auction-pusher-events';
import { PusherService } from 'src/app/Shared/services/pusher/pusher.service';
import {
  IAuctionUpdateEventPayload,
  IBuyerApplicationStatusPayload,
  ITermsAndConditionsPayload,
} from 'src/app/Shared/_models/pusher-events-payload.model';
import { changeAuctionsStatuses } from 'src/app/_utlis/auctions-helpers';
import * as Events from 'src/app/_contstants/pusher-contstants';
import { BaseTableComponent } from 'src/app/Shared/components/base-table/base-table.component';
import { Column } from 'src/app/Shared/_models/column';
import { SearchPipe } from 'src/app/Shared/_pipes/search.pipe';
import { SkeletonLoaderComponent } from 'src/app/Shared/components/skeleton-loader/skeleton-loader.component';
import { FilterByPipe } from 'src/app/Shared/_pipes/filter-by.pipe';
import { RequestToBidButtonComponent } from 'src/app/app-modules/buyer/buyer-shared/components/request-to-bid-button/request-to-bid-button.component';
import { CdkCopyToClipboard } from '@angular/cdk/clipboard';
import { TranslatePipe } from '@ngx-translate/core';
import { SearchInputComponent } from 'src/app/Shared/components/search/search-input.component';
import { LocaleService } from 'src/app/Shared/services/locale/locale.service';
import { LanguageService } from 'src/app/Shared/services/language/language.service';
import { TranslationUpdater } from 'src/app/Shared/helpers/translation-updater';
import { LocalizedNamePipe } from 'src/app/Shared/pipes/localized-name.pipe';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { RolloverRefreshCoordinator } from '../../../../buyer-shared/utils/rollover-refresh-coordinator';

type AuctionAccessFlags = {
  accepted_invited_buyer?: boolean | null;
  auction_buyer_last_record?: unknown | null;
  invited_buyer?: boolean | null;
  request_to_join_status?: boolean | null;
};

export function normalizeAuctionAccessFlags(
  flags: AuctionAccessFlags = {},
): {
  accepted_invited_buyer: boolean;
  auction_buyer_last_record: unknown | null;
  invited_buyer: boolean;
  request_to_join_status: boolean | null;
} {
  return {
    accepted_invited_buyer: flags.accepted_invited_buyer ?? false,
    auction_buyer_last_record: flags.auction_buyer_last_record ?? null,
    invited_buyer: flags.invited_buyer ?? false,
    request_to_join_status: flags.request_to_join_status ?? null,
  };
}

@Component({
  selector: 'app-auctions-list',
  standalone: true,
  imports: [
    BreadCrumbsComponent,
    PaginationResultsComponent,
    NgClass,
    BuyerAuctionCardComponent,
    NgFor,
    NgIf,
    PaginationComponent,
    BaseTableComponent,
    SkeletonLoaderComponent,
    CommonModule,
    RequestToBidButtonComponent,
    CdkCopyToClipboard,
    SearchInputComponent,
    TranslatePipe,
    LocalizedNamePipe,
    MatIconModule,
    MatProgressSpinner,
  ],
  templateUrl: './auctions-list.component.html',
  styleUrl: './auctions-list.component.scss',
  providers: [FilterByPipe],
})
export class AuctionsListComponent implements OnDestroy {
  breadCrumbsItems: Breadcrumb[] = [];
  currentLang: any;
  // pagination
  page: number = 1;
  itemsPerPage: number = CardsPerPage;
  paginationData!: {
    totalPages: number;
    total: number | undefined;
    from: number | undefined;
    to: number | undefined;
  };
  isBrowser: boolean;
  isLoading: boolean = false;
  /**
   * BXS-3589: false while auction cards are rendered from the cached static
   * `allAuctions` response and the per-buyer `AuctionsSettings` merge is still
   * pending. Passed to each card as `statusReady` so the action button shows a
   * placeholder instead of a wrong "Request to Bid" state for Approved or
   * Pending buyers.
   */
  dynamicSettingsLoaded: boolean = false;
  searchVal: string = '';
  filterBy!: string;
  auctions!: any[];
  private subscriptions = new Subscription();
  // Coalesces bursts of realtime (auction.updated / buyer-application) refresh
  // triggers into a single list refetch. Matters now that /buyer/allAuctions is
  // uncached: each refetch hits the DB and several auctions can transition at the
  // same minute boundary. getAllAuctions() already drops stale responses by requestId.
  private realtimeListRefresh$ = new Subject<void>();
  timer: any;
  loggedIn = false;
  calledFirstTime!: boolean;
  user_id!: number;
  private auctionsRequestId = 0;
  tableColumns: Array<Column> = [];
  @ViewChild('auctionNameTemplate', { static: true })
  auctionNameTemplate!: TemplateRef<any>;
  @ViewChild('sellerNameTemplate', { static: true })
  sellerNameTemplate!: TemplateRef<any>;
  @ViewChild('actionsTemplate', { static: true })
  actionsTemplate!: TemplateRef<any>;
  @ViewChild('auctionTypeTemplate', { static: true })
  auctionTypeTemplate!: TemplateRef<any>;
  @ViewChild('copyTemplate', { static: true })
  copyTemplate!: TemplateRef<any>;
  @ViewChild('termsTemplate', { static: true })
  termsTemplate!: TemplateRef<any>;
  isGridLayout: boolean = true; // Default to card layout

  private translationUpdater?: TranslationUpdater;
  private rolloverRefreshCoordinator = new RolloverRefreshCoordinator(2000);
  constructor(
    private auctionService: AuctionService,
    private toastService: ToastService,
    private router: Router,
    private translate: TranslateService,
    private route: ActivatedRoute,
    @Inject(PLATFORM_ID) private platformId: Object,
    private nav: Navigation,
    private titleService: Title,
    private auth: BuyerAuthService,
    private storage: StorageService,
    private termsAcceptance: TermsAndConditionsAcceptanceService,
    private cdr: ChangeDetectorRef,
    private pusherService: PusherService,
    public localeService: LocaleService,
    private languageService: LanguageService,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    if (this.isBrowser) {
      this.currentLang = JSON.parse(
        localStorage.getItem(this.storage.getPrefixedKey('selectedLang')) ??
          '{}',
      );
    }
  }

  ngOnInit(): void {
    this.setBreadcrumbs();
    this.titleService.setTitle('Bid X Sell | All Auctions ');
    this.initializeAuthSubscription();
    if (this.isBrowser) {
      this.subscribeToAcceptedTerms();
    }
    this.initializeRouteSubscription();
    this.subscriptions.add(
      this.realtimeListRefresh$
        .pipe(debounceTime(300))
        .subscribe(() => this.getAllAuctions(false)),
    );
  }

  setBreadcrumbs(): void {
    this.breadCrumbsItems = [
      {
        label: this.translate.instant('buyer_footer.home'),
        url: '/',
        translationKey: 'buyer_footer.home',
      },
      {
        label: this.translate.instant('buyer_header.auctions_list'),
        translationKey: 'buyer_header.auctions_list',
      },
    ];
  }
  ngAfterViewInit() {
    this.tableColumns = [
      // {
      //   columnDef: '#',
      //   header: '#',
      //   cell: (element: Record<string, any>) => null,
      //   template: true,
      //   templateRef: this.copyTemplate,
      //   visible: true,
      // },
      {
        columnDef: 'name',
        header: this.translate.instant('auction.auction_name'),
        translationKey: 'auction_auction_name',
        cell: (element: Record<string, any>) => null,
        template: true,
        templateRef: this.auctionNameTemplate,
        visible: true,
      },
      {
        columnDef: 'seller_name',
        header: this.translate.instant('horse_info.consignor'),
        translationKey: 'horse_info_consignor',
        cell: (element: Record<string, any>) => null,
        template: true,
        templateRef: this.sellerNameTemplate,
        visible: true,
      },

      {
        columnDef: 'auc_type',
        header: this.translate.instant('auction.auction_type'),
        translationKey: 'auction_auction_type',
        cell: (element: Record<string, any>) => null,
        template: true,
        templateRef: this.auctionTypeTemplate,
        visible: true,
      },

      {
        columnDef: 'seller_terms',
        header: this.translate.instant('auction.terms_and_condition'),
        translationKey: 'auction_terms_and_condition',
        cell: (element: Record<string, any>) => null,
        template: true,
        templateRef: this.termsTemplate,
        visible: true,
      },

      {
        columnDef: ' ',
        header: this.translate.instant('horse_info.actions'),
        translationKey: 'horse_info_actions',
        cell: (element: Record<string, any>) => null,
        template: true,
        templateRef: this.actionsTemplate,
        visible: true,
      },
    ];

    // Setup auto-updating translations
    this.translationUpdater = new TranslationUpdater(
      this.languageService,
      () => {
        this.updateTableHeaders();
        this.setBreadcrumbs();
      },
    );
  }

  updateTableHeaders(): void {
    this.tableColumns.forEach((column) => {
      switch (column.columnDef) {
        case 'name':
          column.header = this.languageService.instant('auction.auction_name');
          break;
        case 'seller_name':
          column.header = this.languageService.instant('horse_info.consignor');
          break;
        case 'auc_type':
          column.header = this.languageService.instant('auction.auction_type');
          break;
        case 'seller_terms':
          column.header = this.languageService.instant(
            'auction.terms_and_condition',
          );
          break;
        case ' ':
          column.header = this.languageService.instant('horse_info.actions');
          break;
      }
    });
    this.cdr.detectChanges();
  }
  initializeAuthSubscription() {
    const authSub = this.auth.loggedIn_authorized$.subscribe((res) => {
      this.loggedIn = res;
      if (this.calledFirstTime) {
        this.getAllAuctions(false);
      }
      this.unSubscribeFromChannels();
      this.user_id = this.storage?.userData?.id;
      this.subscribeToChannels();
    });

    this.subscriptions.add(authSub);
  }

  initializeRouteSubscription() {
    const routeSub = this.route.queryParams.subscribe((params) => {
      this.page = +params['page'];
      this.searchVal = params['search'] || '';
      this.filterBy = params['filterBy'] || 'all';
      this.getAllAuctions();
    });
    this.subscriptions.add(routeSub);
  }

  getRowClass = (row: any) => {
    return {
      'withdraw-horse': row.withdrawn_at != null,
    };
  };
  rowClicked(e: any) {
    this.router.navigate(['/buyer/auctions', e.slug]);
  }
  cpy(e: any) {
    e.stopPropagation();
    this.toastService.showInfo(
      this.translate.instant('auction.copied_to_clipboard'),
    );
  }
  goToTermsAndConditions(event: any, element: any) {
    event.stopPropagation();
    const url = `/terms-and-conditions/auction/${element?.id}`;
    window.open(url, '_blank');
  }
  handleFilter(e: any) {
    const filterBy = e.target.value;
    const queryParams: any = { filterBy };
    if (this.searchVal) {
      queryParams.search = this.searchVal;
    }
    this.router.navigate(['/buyer/auctions/list/all'], {
      queryParams,
    });
  }

  handleActions(e: { action: string; data: Auction }): void {
    const { action, data } = e;
    const queryParams = {
      auctionTypePage: 'auctions',
    };
    switch (action) {
      case 'place':
        this.router.navigate(['/buyer/auctions', data.slug], {
          queryParams,
        });

        break;
      case 'time_ended':
        // BXS-3590: A card's local timer just hit zero. For an active auction
        // this is the active → gradual-ending transition; for an upcoming
        // auction it is upcoming → active. Both require a full reload because
        // the dynamic `AuctionsSettings` endpoint does NOT return
        // `gradual_ending_settings` (BuyerAuctionsSettingsBusinessService only
        // surfaces running/ended/bid/buyer flags). Without the static
        // `allAuctions` payload, the auction stays with
        // `gradual_ending_settings: null` and `timer_end_date` resolves to the
        // already-elapsed `active_timer_end_date`, leaving the card frozen at
        // 00:00:00:00 until the user navigates away and back. The 2-second
        // rollover window still lets a Pusher `auction.updated` event cancel
        // the fallback when the backend cron fires it in time.
        this.scheduleRolloverFallback(data?.id);
        break;
      case 'load_data':
        this.getAllAuctions();

        break;
    }
  }

  getAllAuctions(load = true): void {
    this.toastService.clear();
    this.calledFirstTime = true;
    const requestId = ++this.auctionsRequestId;

    if (load) {
      this.isLoading = true;
    }

    this.auctionService
      .getAllAuctions(
        this.searchVal,
        this.page || 1,
        this.itemsPerPage,
        this.filterBy || 'all',
      )
      .subscribe({
        next: (response: {
          data: { items: Auction[]; pagination: IPagination };
          current_datetime: Date | string;
        }) => {
          if (requestId !== this.auctionsRequestId) {
            return;
          }

          this.isLoading = false;

          this.paginationData = getPaginationData(
            response?.data?.pagination,
            this.itemsPerPage,
          );
          // BXS-3589: cards are about to render from cached static data without
          // the buyer's resolved per-auction status; hold the action button in
          // a placeholder state until loadDynamicAuctionSettings() merges it.
          this.dynamicSettingsLoaded = false;
          this.auctions =
            response?.data?.items?.map(
              this.mapStaticAuctionData(response.current_datetime),
            ) ?? [];

          this.loadDynamicAuctionSettings(
            requestId,
            this.auctions.map((auction) => auction?.id).filter(Boolean),
          );
        },
        error: (error) => {
          if (requestId !== this.auctionsRequestId) {
            return;
          }

          this.isLoading = false;
          // BXS-3589: no dynamic merge follows a failed static load.
          this.dynamicSettingsLoaded = true;
          console.error('Error fetching auctions:', error);
          this.toastService.showError(
            error?.error?.Error?.[0] ??
              'An error occurred while fetching auctions.',
          );
        },
        complete: () => {
          if (requestId !== this.auctionsRequestId) {
            return;
          }

          this.isLoading = false;
        },
      });
  }

  private loadDynamicAuctionSettings(requestId: number, auctionIds: number[]): void {
    const uniqueAuctionIds = [...new Set(auctionIds)] as number[];
    if (!uniqueAuctionIds.length) {
      // BXS-3589: no auctions to fetch status for — nothing left to wait on.
      this.dynamicSettingsLoaded = true;
      return;
    }

    this.auctionService
      .getAuctionsSettings({
        auction_ids: uniqueAuctionIds,
      })
      .subscribe({
        next: (response: { data: any[]; current_datetime?: Date | string }) => {
          if (requestId !== this.auctionsRequestId) {
            return;
          }

          this.mergeDynamicAuctionSettings(
            response?.data ?? [],
            response?.current_datetime,
          );
          // BXS-3589: per-buyer status merged — the action button can render.
          this.dynamicSettingsLoaded = true;
        },
        error: (error) => {
          if (requestId !== this.auctionsRequestId) {
            return;
          }

          console.warn('Error fetching dynamic auction settings:', error);
          // BXS-3589: reveal the button with static defaults rather than
          // leaving it stuck on the placeholder if the settings call fails.
          this.dynamicSettingsLoaded = true;
        },
      });
  }

  private mapStaticAuctionData(current_datetime: Date | string) {
    return (el: Auction) => {
      const {
        accepted_invited_buyer,
        auction_buyer_last_record,
        end_date,
        ended,
        highest_bid_amount,
        highest_bid_amount_not_winning_items,
        invited_buyer,
        latest_bid_time,
        request_to_join,
        request_to_join_status,
        running,
      } = el.auction_settings ?? {};

      const normalizedAccessFlags = normalizeAuctionAccessFlags({
        accepted_invited_buyer,
        auction_buyer_last_record,
        invited_buyer,
        request_to_join_status,
      });

      const baseActiveEndDate = el?.auction_end_date;
      const settingsEndDate = end_date;
      // BXS-3590: raw auction extended_end_date = the real main-bidding end.
      const mainExtendedEndDate = el?.extended_end_date;
      const activeTimerEndDate = this.resolveActiveTimerEndDate(
        baseActiveEndDate,
        mainExtendedEndDate,
      );
      const type =
        this.deriveAuctionTypeFromFlags(running, ended) ??
        // BXS-3590: a static payload carrying gradual_ending_settings with a
        // pending lot is an ACTIVE auction in its gradual-ending phase — never
        // let the date-based check type it 'previous' (now > auction_end_date)
        // before the dynamic running/ended merge resolves it. This removes the
        // "Previous" flash and the SSR-hydration corruption on hard refresh.
        (el?.gradual_ending_settings?.next_item_finish_at ? 'active' : null) ??
        this.deriveAuctionTypeFromDates(
          el.auction_start_date,
          activeTimerEndDate,
          current_datetime,
        );

      const data = { ...el, auc_type: type };
      delete data?.auction_settings;

      return {
        ...data,
        ...normalizedAccessFlags,
        end_date,
        ended,
        highest_bid_amount,
        highest_bid_amount_not_winning_items,
        latest_bid_time,
        request_to_join,
        running,
        base_active_end_date: baseActiveEndDate,
        base_extended_end_date: mainExtendedEndDate,
        settings_end_date: settingsEndDate,
        active_timer_end_date: activeTimerEndDate,
        current_date: current_datetime,
        timer_end_date: this.resolveTimerEndDate({
          auc_type: type,
          auction_start_date: el?.auction_start_date,
          current_date: current_datetime,
          active_timer_end_date: activeTimerEndDate,
          gradual_ending_settings: el?.gradual_ending_settings,
        }),
      };
    };
  }

  private mergeDynamicAuctionSettings(
    dynamicSettings: any[],
    currentDatetime?: Date | string,
  ): void {
    if (!Array.isArray(dynamicSettings) || !this.auctions?.length) {
      return;
    }

    const settingsMap = new Map<number, any>(
      dynamicSettings
        .filter((setting) => setting?.id != null)
        .map((setting) => [setting.id, setting]),
    );

    this.auctions = this.auctions.map((auction) => {
      const dynamic = settingsMap.get(auction?.id);
      if (!dynamic) {
        return auction;
      }

      const running = dynamic?.running ?? auction?.running;
      const ended = dynamic?.ended ?? auction?.ended;
      const normalizedAccessFlags = normalizeAuctionAccessFlags({
        accepted_invited_buyer:
          dynamic?.accepted_invited_buyer ?? auction?.accepted_invited_buyer,
        auction_buyer_last_record:
          dynamic?.auction_buyer_last_record ??
          auction?.auction_buyer_last_record,
        invited_buyer: dynamic?.invited_buyer ?? auction?.invited_buyer,
        request_to_join_status:
          dynamic?.request_to_join_status ?? auction?.request_to_join_status,
      });
      const aucType =
        this.deriveAuctionTypeFromFlags(running, ended) ?? auction?.auc_type;
      const currentDate = currentDatetime ?? auction?.current_date;
      const gradualEnding =
        dynamic?.gradual_ending_settings ?? auction?.gradual_ending_settings;
      const baseActiveEndDate =
        auction?.base_active_end_date ?? auction?.auction_end_date;
      const settingsEndDate =
        dynamic?.end_date ?? auction?.settings_end_date ?? auction?.end_date;
      // BXS-3590: use the RAW main extended end preserved from the static map
      // (base_extended_end_date / the original extended_end_date) — NOT
      // dynamic.extended_end_date, which is the item-staggered last-lot time
      // during gradual ending.
      const mainExtendedEndDate =
        auction?.base_extended_end_date ?? auction?.extended_end_date;
      const activeTimerEndDate = this.resolveActiveTimerEndDate(
        baseActiveEndDate,
        mainExtendedEndDate,
      );

      return {
        ...auction,
        highest_bid_amount:
          dynamic?.highest_bid_amount ?? auction?.highest_bid_amount,
        highest_bid_amount_not_winning_items:
          dynamic?.highest_bid_amount_not_winning_items ??
          auction?.highest_bid_amount_not_winning_items,
        latest_bid_time: dynamic?.latest_bid_time ?? auction?.latest_bid_time,
        updated_end_date_time:
          dynamic?.updated_end_date_time ?? auction?.updated_end_date_time,
        gradual_ending_settings: gradualEnding,
        extended_end_date: gradualEnding
          ? auction?.extended_end_date // Preserve correct base end date for gradual-ending auctions
          : (dynamic?.extended_end_date ?? auction?.extended_end_date),
        end_date: settingsEndDate,
        settings_end_date: settingsEndDate,
        base_active_end_date: baseActiveEndDate,
        base_extended_end_date: mainExtendedEndDate,
        active_timer_end_date: activeTimerEndDate,
        running,
        ended,
        ...normalizedAccessFlags,
        request_to_join: dynamic?.request_to_join ?? auction?.request_to_join,
        buyer_accepted_seller_terms:
          dynamic?.buyer_accepted_seller_terms ??
          auction?.buyer_accepted_seller_terms,
        buyer_status: dynamic?.buyer_status ?? auction?.buyer_status,
        current_date: currentDate,
        auc_type: aucType,
        timer_end_date: this.resolveTimerEndDate({
          auc_type: aucType,
          auction_start_date: auction?.auction_start_date,
          current_date: currentDate,
          active_timer_end_date: activeTimerEndDate,
          gradual_ending_settings: gradualEnding,
        }),
      };
    });
  }

  /**
   * BXS-3590: the active countdown must target the auction's real main-bidding
   * end — the LATER of `auction_end_date` and the raw `extended_end_date` column
   * (the latter is bumped by last-minute bid extensions). Targeting only the
   * base `auction_end_date` made a bid-extended auction freeze at 00:00:00:00
   * from the base end until the (later) real end.
   *
   * IMPORTANT: `mainExtendedEndDate` must be the RAW auction `extended_end_date`
   * (main end). It must NOT be the dynamic `AuctionsSettings.extended_end_date`,
   * which is the item-staggered last-lot time during gradual ending.
   */
  private resolveActiveTimerEndDate(
    auctionEndDate?: Date | string,
    mainExtendedEndDate?: Date | string,
  ): Date | string | undefined {
    return (
      this.latestDate(auctionEndDate, mainExtendedEndDate) ??
      auctionEndDate ??
      mainExtendedEndDate
    );
  }

  private latestDate(
    first?: Date | string,
    second?: Date | string,
  ): Date | string | undefined {
    const firstTime = this.toEpoch(first);
    const secondTime = this.toEpoch(second);
    if (firstTime == null) {
      return second ?? undefined;
    }
    if (secondTime == null) {
      return first ?? undefined;
    }
    return firstTime >= secondTime ? first : second;
  }

  private resolveTimerEndDate(
    auction: {
      auc_type?: string;
      auction_start_date?: Date | string;
      current_date?: Date | string;
      active_timer_end_date?: Date | string;
      gradual_ending_settings?: { next_item_finish_at?: Date | string } | null;
    },
    realtimeGradualEndTime?: Date | string,
  ): Date | string | undefined {
    if (auction?.auc_type === 'upcoming') {
      return auction?.auction_start_date;
    }

    if (auction?.auc_type !== 'active') {
      return undefined;
    }

    const baseActiveEndDate = auction?.active_timer_end_date;
    const baseActiveEnded = this.hasDateElapsed(
      baseActiveEndDate,
      auction?.current_date,
    );

    if (!baseActiveEnded) {
      return baseActiveEndDate;
    }

    // BXS-3590: base end elapsed → the auction is in (or entering) its gradual
    // ending phase. Return the soonest FUTURE close time and NEVER fall back to
    // the already-elapsed base end (that pins the card at 00:00:00:00 / blank).
    // When no valid future close time exists yet, return undefined so the caller
    // refetches instead of rendering a dead timer.
    return this.firstFutureDate(auction?.current_date, [
      auction?.gradual_ending_settings?.next_item_finish_at,
      realtimeGradualEndTime,
    ]);
  }

  private firstFutureDate(
    currentDate: Date | string | undefined,
    candidates: Array<Date | string | undefined>,
  ): Date | string | undefined {
    for (const candidate of candidates) {
      if (candidate != null && !this.hasDateElapsed(candidate, currentDate)) {
        return candidate;
      }
    }
    return undefined;
  }

  private hasDateElapsed(
    targetDate?: Date | string,
    currentDate?: Date | string,
  ): boolean {
    const targetTime = this.toEpoch(targetDate);
    if (targetTime == null) {
      return false;
    }

    const currentTime = this.toEpoch(currentDate) ?? Date.now();
    return currentTime >= targetTime;
  }

  private toEpoch(value?: Date | string): number | null {
    const time = new Date(value ?? '').getTime();
    return Number.isFinite(time) ? time : null;
  }

  private deriveAuctionTypeFromFlags(
    running?: boolean,
    ended?: boolean,
  ): 'active' | 'upcoming' | 'previous' | null {
    if (running === true && ended === false) {
      return 'active';
    }

    if (running === false && ended === true) {
      return 'previous';
    }

    if (running === false && ended === false) {
      return 'upcoming';
    }

    return null;
  }

  private deriveAuctionTypeFromDates(
    auctionStartDate: string | Date | undefined,
    auctionEndDate: string | Date | undefined,
    currentDatetime: string | Date | undefined,
  ): 'active' | 'upcoming' | 'previous' {
    const current = new Date(currentDatetime ?? '').getTime();
    const start = new Date(auctionStartDate ?? '').getTime();
    const end = new Date(auctionEndDate ?? '').getTime();

    if (!Number.isFinite(current) || !Number.isFinite(start) || !Number.isFinite(end)) {
      return 'upcoming';
    }

    if (current < start) {
      return 'upcoming';
    }

    if (current > end) {
      return 'previous';
    }

    return 'active';
  }

  onPageChanged(page: number): void {
    const queryParams: any = { page };
    if (this.searchVal) {
      queryParams.search = this.searchVal;
    }
    if (this.filterBy) {
      queryParams.filterBy = this.filterBy;
    }

    this.router.navigate(['/buyer/auctions/list/all'], {
      queryParams,
    });
  }
  handleSearch(e: string) {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      if (e != this.searchVal) {
        this.searchVal = e;
        const queryParams: any = { search: this.searchVal };
        if (this.filterBy) {
          queryParams.filterBy = this.filterBy;
        }
        this.router.navigate(['/buyer/auctions/list/all'], {
          queryParams,
        });
      }
    }, 1500);
  }
  resetSearch() {
    const queryParams: any = {};

    if (this.filterBy) {
      queryParams.filterBy = this.filterBy;
    }
    this.router.navigate(['/buyer/auctions/list/all'], { queryParams });
  }
  isTableLoaded = false;
  isGridLoaded = true;

  toggleLayout() {
    if (this.isGridLayout) {
      // Switching from grid to table
      this.isGridLayout = false;
      this.isTableLoaded = false;
      this.isGridLoaded = true; // The grid is still in DOM

      // Give UI time to hide grid, then show table
      setTimeout(() => {
        this.isTableLoaded = true;
        this.cdr.detectChanges();
      }, 50);
    } else {
      // Switching from table to grid
      this.isGridLayout = true;
      this.isTableLoaded = true; // The table is still in DOM
      this.isGridLoaded = false;

      // Give UI time to hide table, then show grid
      setTimeout(() => {
        this.isGridLoaded = true;
        this.cdr.detectChanges();
      }, 50);
    }
    setTimeout(() => {
      this.subscribeToChannels();
    }, 500);
  }
  cardClicked(e: any, item: any) {
    e.stopPropagation();
    const queryParams = {
      // auctionTypePage: 'my_auctions',
    };

    this.router.navigate(['/buyer/auctions', item.slug], { queryParams });
  }
  subscribeToAcceptedTerms() {
    const termsSub = this.termsAcceptance.buyerAccepted$.subscribe((value) => {
      if (value?.isAccepted === 'accepted') {
        this.auctions.forEach((element: any) => {
          if (element?.id === value?.auctionId) {
            element.buyer_accepted_seller_terms = value?.isAccepted;
          }
        });
        this.cdr.detectChanges();
      }
    });

    this.subscriptions.add(termsSub);
  }

  subscribeToChannels() {
    const channels = getAuctionChannels(this.user_id);
    this.pusherService.subscribeToMultiChannels(channels, (data: any) => {
      this.handlePusherEvents(data);
    });
  }

  handlePusherEvents(eventData: { eventName: string; data: any }) {
    const { eventName, data } = eventData;
    switch (eventName) {
      case Events.TERMS_CONDITIONS_UPDATE:
        this.handleTermsAndConditionUpdatedEvent(data);
        break;

      case Events.BUYER_APP_ACCEPTED:
        this.handleBuyerAppEvent(data, true);
        break;

      case Events.BUYER_APP_REJECTED:
        this.handleBuyerAppEvent(data, false);
        break;

      case Events.AUCTION_UPDATED:
        this.handleAuctionUpdate(data);
        break;
    }
  }

  handleTermsAndConditionUpdatedEvent(data: ITermsAndConditionsPayload) {
    if (data?.affected_auctions) {
      data?.affected_auctions.forEach((element: number) => {
        const matchedAuction = this.auctions.find(
          (auc: any) => auc.id === element,
        );

        if (matchedAuction) {
          matchedAuction.seller_terms = data?.terms_and_conditions;
          matchedAuction.buyer_accepted_seller_terms = 'not accepted';
        }
      });
    }
  }

  handleBuyerAppEvent(data: IBuyerApplicationStatusPayload, accepted: boolean) {
    if (data.auction_ids) {
      this.auctions = [
        ...changeAuctionsStatuses(data.auction_ids, accepted, this.auctions),
      ];
    }
    if (accepted) {
      this.realtimeListRefresh$.next();
    }
  }

  handleAuctionUpdate(data: IAuctionUpdateEventPayload) {
    const auctionIn = this.auctions?.findIndex(
      (el) => el?.id == data?.auction_id,
    );

    if (data?.status?.active || data?.status?.upcoming) {
      if (auctionIn !== -1) {
        // Derive new auc_type from Pusher status
        const newAucType = data?.status?.active
          ? 'active'
          : data?.status?.upcoming
            ? 'upcoming'
            : 'previous';
        const currentAucType = this.auctions[auctionIn].auc_type;

        // If auction status changed (e.g., upcoming → active), refresh from API.
        // Pusher end_time may contain accumulated item end dates, not auction base end date.
        if (currentAucType !== newAucType) {
          this.rolloverRefreshCoordinator.cancelFallbackOnRealtimeUpdate(
            data?.auction_id,
          );
          this.realtimeListRefresh$.next();
          return;
        }

        // Same status - update in place.
        const currentAuction = this.auctions[auctionIn];
        const gradualEnding =
          data?.gradual_ending_settings ?? currentAuction?.gradual_ending_settings;
        const currentDate = data?.current_datetime ?? currentAuction?.current_date;
        const isGradualPhase =
          this.hasDateElapsed(
            currentAuction?.active_timer_end_date,
            currentDate,
          ) && !!gradualEnding;
        const newTimerEndDate = this.resolveTimerEndDate(
          {
            ...currentAuction,
            auc_type: currentAucType,
            current_date: currentDate,
            gradual_ending_settings: gradualEnding,
          },
          isGradualPhase ? data?.end_time : undefined,
        );

        // BXS-3590: only adopt the in-place realtime update when it yields a
        // valid FUTURE timer. If it would resolve to an elapsed/absent date
        // (e.g. next_item_finish_at not published yet at the transition), keep
        // the rollover fallback alive and trigger a full refetch instead — never
        // strand the card on a dead 00:00:00:00 / blank timer.
        if (newTimerEndDate == null) {
          this.realtimeListRefresh$.next();
          return;
        }

        this.rolloverRefreshCoordinator.cancelFallbackOnRealtimeUpdate(
          data?.auction_id,
        );
        this.auctions[auctionIn] = {
          ...currentAuction,
          highest_bid_amount: data.highest_bid_amount_not_winning_items,
          highest_bid_amount_not_winning_items:
            data.highest_bid_amount_not_winning_items,
          // Pusher end_time can be auction-items aggregate; use it for active timer updates only in gradual phase.
          extended_end_date: isGradualPhase
            ? (data?.end_time ?? currentAuction?.extended_end_date)
            : currentAuction?.extended_end_date,
          current_date: currentDate,
          gradual_ending_settings: gradualEnding,
          timer_end_date: newTimerEndDate,
        };
      } else {
        this.rolloverRefreshCoordinator.cancelFallbackOnRealtimeUpdate(
          data?.auction_id,
        );
        // Auction not currently in the list (e.g. it just crossed its preview-start
        // and became visible) — pull a fresh page so it appears in real time.
        this.realtimeListRefresh$.next();
      }
    }
  }

  private scheduleRolloverFallback(auctionId?: number, dynamicOnly = false): void {
    this.rolloverRefreshCoordinator.scheduleFallbackRefresh(
      () => {
        if (dynamicOnly && this.auctions?.length) {
          this.loadDynamicAuctionSettings(
            this.auctionsRequestId,
            this.auctions.map((a) => a?.id).filter(Boolean),
          );
        } else {
          this.getAllAuctions(false);
        }
      },
      auctionId,
    );
  }

  unSubscribeFromChannels() {
    const channels = getAuctionChannels(this.user_id).map(
      (el) => el.channelName,
    );

    if (channels.length) {
      this.pusherService.unsubscribeFromChannels(channels);
    }
  }

  // Buyer status helper methods for table view
  isBlocked(element: any): boolean {
    return element?.buyer_status?.is_blocked === true;
  }

  isSuspended(element: any): boolean {
    return element?.buyer_status?.is_suspended === true;
  }

  isBlockedOrSuspended(element: any): boolean {
    return this.isBlocked(element) || this.isSuspended(element);
  }

  getSellerEmail(element: any): string {
    return element?.seller?.user?.email || '';
  }

  ngOnDestroy(): void {
    this.rolloverRefreshCoordinator.dispose();

    if (this.translationUpdater) {
      this.translationUpdater.destroy();
    }
    this.subscriptions.unsubscribe();
    this.realtimeListRefresh$.complete();
    this.unSubscribeFromChannels();

    if (this.timer) {
      clearTimeout(this.timer);
    }
  }

  trackByAuctionId(index: number, auction: any): number {
    return auction?.id ?? index;
  }
}
